module.exports = __webpack_public_path__ + "static/img/200279.1f4d369b.png";